import { render, staticRenderFns } from "./AlignRight.vue?vue&type=template&id=6491f87a&"
import script from "./AlignRight.vue?vue&type=script&lang=js&"
export * from "./AlignRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports